var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_889_3706",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_889_3706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.75 18.3846H13.2499V13.9499L15.1 15.7999L16.1538 14.7307L12.5 11.0769L8.84615 14.7307L9.91535 15.7846L11.75 13.9499V18.3846ZM6.8077 21.5C6.30257 21.5 5.875 21.325 5.525 20.975C5.175 20.625 5 20.1974 5 19.6923V4.3077C5 3.80257 5.175 3.375 5.525 3.025C5.875 2.675 6.30257 2.5 6.8077 2.5H14.75L20 7.74995V19.6923C20 20.1974 19.825 20.625 19.475 20.975C19.125 21.325 18.6974 21.5 18.1922 21.5H6.8077ZM14 8.49995V3.99998H6.8077C6.73077 3.99998 6.66024 4.03203 6.59612 4.09613C6.53202 4.16024 6.49997 4.23077 6.49997 4.3077V19.6923C6.49997 19.7692 6.53202 19.8397 6.59612 19.9038C6.66024 19.9679 6.73077 20 6.8077 20H18.1922C18.2692 20 18.3397 19.9679 18.4038 19.9038C18.4679 19.8397 18.5 19.7692 18.5 19.6923V8.49995H14Z",
    fill: "#FBFBFB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload_file.7e61e778c2350afddf80629edd6a1a05.svg";
export { ForwardRef as ReactComponent };